<script setup>
import { clone } from 'lodash';
import { ref } from 'vue';
import SelectCifra from './SelectCifra.vue';

/**
 * Componente para in input donde se pueden ir poniendo tags
 */

const props = defineProps({
  inputName: { type: String, required: true },
  options: { type: Array, default: () => ([]) },
  modelValue: { type: Array, default: () => ([]) },
});

const emits = defineEmits(['update:modelValue']);

const modelInterno = ref(clone(props.modelValue));

function addTag(newTag) {
  emits('update:modelValue', modelInterno.value.push(newTag));
}

</script>

<template>
  <input type="hidden" :name="inputName" :value="modelInterno?.join(',')">
  <SelectCifra
    v-model="modelInterno"
    :options="options"
    :multiple="true"
    :taggable="true"
    v-bind="$attrs"
    @tag="addTag"
  >
  </SelectCifra>
</template>
